import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useContext } from 'react';
import { TaskContext } from '../Context/TaskContex';
export default function Task({ task,  showUpdate }) {
    const { toggleTask, deletTask} = useContext(TaskContext)
 
  const handleClickOpen = (e) => {
    showUpdate(task)
  }


    return (
        <>
            <Card sx={{
                minWidth: 275,
                marginTop: 3,
                // تغيير لون الخلفية إذا كانت المهمة مكتملة
                background: task.isCompleted ? '#2e7d32' : '#242e87',
                transition: '0.3s',
                color: "white",
            }}>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 7 }}>
                            <Typography variant='h6' sx={{
                                textAlign: 'right',
                                // إضافة خط شطب على النص إذا اكتملت المهمة
                                textDecoration: task.isCompleted ? 'line-through' : 'none'
                            }}>
                                {task.title}
                            </Typography>
                            <Typography sx={{ textAlign: 'right', textDecoration: task.isCompleted ? 'line-through' : 'none' }}>
                                {task.details}
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 5 }} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                            <Stack direction="row" spacing={0.5} sx={{ direction: "ltr" }}>
                                <Button variant="contained" color="error" size="small" onClick={() => deletTask(task.id)}>حذف</Button>
                                {/* زر التعديل */}
                                <Button variant="contained" color="primary" size="small" onClick={handleClickOpen}>تعديل</Button>
                               
                                {/* ====زر التعديل==== */}
                                {/* زر الإكمال */}
                                <Button
                                    onClick={() => toggleTask(task.id)} // استدعاء الدالة عند الضغط
                                    variant="contained"
                                    color="success"
                                    size="small"
                                >
                                    {task.isCompleted ? 'تراجع' : 'إكمال'}
                                </Button>
                                {/* =====زر الإكمال===== */}
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}
